module.exports = __webpack_public_path__ + "static/media/mazaZolePlayed_500000_1000000.cb791dde.png";